import { LogRecordStatus } from '@fleet-beat/core';

export interface DriverStatusObjectModel {
  driving: { name: LogRecordStatus.Driving; iconConfig: DriverStatusIconConfig; active?: boolean };
  onDuty: { name: LogRecordStatus.OnDuty; iconConfig: DriverStatusIconConfig; active?: boolean };
  sleepBerth: { name: LogRecordStatus.SleeperBerth; iconConfig: DriverStatusIconConfig; active?: boolean };
  yardMove: { name: LogRecordStatus.YardMove; iconConfig: DriverStatusIconConfig; active?: boolean };
  personalConveyance: {
    name: LogRecordStatus.PersonalConveyance;
    iconConfig: DriverStatusIconConfig;
    active?: boolean;
  };
  off: { name: LogRecordStatus.OffDuty; iconConfig: DriverStatusIconConfig; active?: boolean };
  powerOff: { name: LogRecordStatus.PowerOffConventional; iconConfig: DriverStatusIconConfig; active?: boolean };
  powerOn: { name: LogRecordStatus.PowerOnConventional; iconConfig: DriverStatusIconConfig; active?: boolean };
  intermediate: {
    name: LogRecordStatus.IntermediateConventional;
    iconConfig: DriverStatusIconConfig;
    active?: boolean;
  };
  certification: {
    name: LogRecordStatus.Certification;
    iconConfig: DriverStatusIconConfig;
    active?: boolean;
  };
  login: {
    name: LogRecordStatus.Login;
    iconConfig: DriverStatusIconConfig;
    active?: boolean;
  };
  logout: {
    name: LogRecordStatus.Logout;
    iconConfig: DriverStatusIconConfig;
    active?: boolean;
  };
}

export interface DriverStatusIconConfig {
  text: string;
  icon?: string;
  externalIcon?: boolean;
  light: {
    bg: string;
    color: string;
    counterColor?: string;
    counterBg: string;
  };
  dark: {
    bg: string;
    color: string;
    counterColor?: string;
    counterBg: string;
  };
}

export interface DriverStatusModel {
  name: LogRecordStatus;
  count?: number;
  iconConfig: DriverStatusIconConfig;
  active?: boolean;
}
